import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import NLink from '@src/components/NLink';

import css from './style.module.scss';

const LinkLines = (props) => {
	const { title, groups, children } = props;
	return (
		<div className={cn(css.block)}>
			{title && <div className={cn(css.title)}>{title}</div>}
			{groups.length > 0 && (
				<div className={cn(css.groups)}>
					{groups.map((group) => {
						return (
							<div key={group.id} className={cn(css.group)}>
								{group.title && (
									<div className={cn(css.groupTitle)}>
										{group.title}
									</div>
								)}
								{group.lines.length > 0 && (
									<div className={cn(css.groupLines)}>
										{group.lines.map((line) => {
											return (
												<NLink
													key={line.id}
													href={line.href}
													{...line.link}
												>
													<a className={cn(css.link)}>
														{line.label}
													</a>
												</NLink>
											);
										})}
									</div>
								)}
							</div>
						);
					})}
				</div>
			)}
			{children}
		</div>
	);
};

LinkLines.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	title: PropTypes.string,
	groups: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			title: PropTypes.string,
			lines: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.oneOfType([
						PropTypes.string,
						PropTypes.number,
					]),
					label: PropTypes.string,
					href: PropTypes.string,
					link: PropTypes.shape(NLink.propTypes),
				}),
			),
		}),
	),
};

LinkLines.defaultProps = {
	children: undefined,
	title: undefined,
	groups: [],
};

export default LinkLines;
